"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDraggable_1 = __importDefault(require("../draggable/useDraggable"));
function useResizer(props) {
    const { initialPosition = { x1: 10, x2: 40 }, onStart, onMove, onEnd, parentElement, } = props;
    const currentPosition = (0, react_1.useRef)(initialPosition);
    const prevPosition = (0, react_1.useRef)(initialPosition);
    const activeRef = (0, react_1.useRef)(false);
    const triggerEvent = (0, react_1.useRef)((position, status) => {
        switch (status) {
            case 'start':
                onStart?.(position);
                activeRef.current = true;
                break;
            case 'move':
                onMove?.(position);
                break;
            case 'end':
                prevPosition.current = position;
                activeRef.current = false;
                onEnd?.(position);
                break;
            default:
                break;
        }
    });
    const right = (0, useDraggable_1.default)({
        position: { x: initialPosition.x2, y: 0 },
        parentElement,
        fromEdge: true,
    });
    const left = (0, useDraggable_1.default)({
        position: { x: initialPosition.x1, y: 0 },
        parentElement,
        fromEdge: true,
    });
    (0, react_1.useEffect)(() => {
        currentPosition.current = {
            x1: left.position.value.x,
            x2: right.position.value.x,
        };
    }, [left.position.value.x, right.position.value.x]);
    (0, react_1.useEffect)(() => {
        const { value: { x }, action, } = left.position;
        const position = {
            x1: x,
            x2: currentPosition.current.x2,
        };
        triggerEvent.current(position, action);
    }, [left.position]);
    (0, react_1.useEffect)(() => {
        const { value: { x }, action, } = right.position;
        const position = {
            x1: currentPosition.current.x1,
            x2: x,
        };
        triggerEvent.current(position, action);
    }, [right.position]);
    return {
        left,
        right,
        prevPosition: prevPosition.current,
        currentPosition: currentPosition.current,
        isActive: activeRef.current,
    };
}
exports.default = useResizer;
